import type {
  ICustomerOrderSummary,
  ICustomerOrderSummary4432PerCurrencyFees,
  ICustomerOrderSummary4432PerCurrencyPnL,
} from './types';

export class CustomerDealSummary {
  Spread: ICustomerOrderSummary['TargetSpread'];

  FilledSpread: ICustomerOrderSummary['ActualSpread'];

  PnL: ICustomerOrderSummary4432PerCurrencyPnL[] | undefined;

  Fees: ICustomerOrderSummary4432PerCurrencyFees[] | undefined;

  SalesCommission: ICustomerOrderSummary['SalesCommission'];

  constructor(data: ICustomerOrderSummary | undefined) {
    this.Spread = data?.TargetSpread;
    this.FilledSpread = data?.ActualSpread;
    // Need to reverse the PnL since we expect base to be first, quote second.
    this.PnL = data?.PerCurrencyPnL != null ? [...data.PerCurrencyPnL].reverse() : undefined;
    this.Fees = data?.PerCurrencyFees != null ? [...data.PerCurrencyFees].reverse() : undefined;
    this.SalesCommission = data?.SalesCommission;
  }
}
